"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var man = exports.man = { "viewBox": "0 0 512 512", "children": [{ "name": "path", "attribs": { "d": "M256,106.6c20.6,0.1,37.3-16.6,37.3-37.3c0-20.6-16.7-37.3-37.3-37.3c-20.6,0-37.3,16.7-37.3,37.3\r\n\tC218.7,89.9,235.4,106.6,256,106.6z" }, "children": [] }, { "name": "g", "attribs": {}, "children": [{ "name": "path", "attribs": { "d": "M293.4,115H256h-37.4c-28.2,0-46.6,24.8-46.6,48.4V277c0,22,31,22,31,0V172h6v285.6c0,30.4,42,29.4,43,0V293h7h1v164.7\r\n\t\tc1.7,31.2,43,28.2,43-0.1V172h5v105c0,22,32,22,32,0V163.4C340,139.9,321.5,115,293.4,115z" }, "children": [{ "name": "path", "attribs": { "d": "M293.4,115H256h-37.4c-28.2,0-46.6,24.8-46.6,48.4V277c0,22,31,22,31,0V172h6v285.6c0,30.4,42,29.4,43,0V293h7h1v164.7\r\n\t\tc1.7,31.2,43,28.2,43-0.1V172h5v105c0,22,32,22,32,0V163.4C340,139.9,321.5,115,293.4,115z" }, "children": [] }] }] }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/ionicons/man.js
// module id = 1584
// module chunks = 0